import { Button, Inbox } from "@app/ui";
import { useI18n } from "../../lib/useI18n.js";

/** The inbox button shown in the calendar header (toggles the docked panel). */
export function InboxToggle({ open, onToggle }: { open: boolean; onToggle: () => void }) {
  const { t } = useI18n();
  return (
    <Button variant={open ? "primary" : "outline"} size="sm" onClick={onToggle} title={t("inbox.toggle")} aria-label={t("inbox.toggle")} aria-pressed={open}>
      <Inbox className="h-4 w-4" /> {t("common.inbox")}
    </Button>
  );
}
